
define('text!modules/core/modules/translate/directives/language-switch/template-select.html',[],function () { return '<select name=locale class="o-select__white u-widthAuto" ng-model=SwitchCtrl.language ng-options="language.locale as language.key | translate for language in SwitchCtrl.languages" ng-change="SwitchCtrl.setLanguage( SwitchCtrl.language )" ng-required=true></select>';});

